<nav class="navbar navbar-expand-lg navbar-dark d-lg-none px-3 fixed-top">
  <button
    class="navbar-toggler ml-auto"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
    (click)="toggleSidebar()"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="header-icons">
    <button *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'ADMIN']" class="btn btn-link">
      <app-icam-icon iconName="bell" class="icon-bell" [isDefault]="true" />
      @if (notifications.length > 0) {
        <span class="badge">{{ notifications.length }} </span>
      }
    </button>
    <div
      class="btn btn-user"
      (click)="toggleDropdown()"
      (keydown.enter)="toggleDropdown()"
      tabindex="0"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      @if (userImage) {
        <img [src]="userImage" class="user-image" alt="Profile" />
      } @else {
        <app-icam-icon [iconName]="'user'" class="icon-user" />
      }
    </div>
    @if (dropdownOpen) {
      <div class="dropdown-menu">
        <a class="dropdown-item" routerLink="/account" (click)="closeDropdown()">{{ 'COMMON.ACCOUNT' | translate }}</a>
        <div class="dropdown-divider"></div>
        <a
          class="dropdown-item"
          (click)="onLogout(); closeDropdown()"
          (keydown.enter)="onLogout(); closeDropdown()"
          tabindex="0"
          role="button"
          >{{ 'COMMON.LOGOUT' | translate }}</a
        >
      </div>
    }
  </div>
</nav>
<div class="sidebar collapse" [ngClass]="{ show: isSidebarVisible, light: isLight, dark: !isLight }">
  <div class="sidebar-upper">
    <div class="logo">
      <button type="button" class="close-button" (click)="toggleSidebar()">
        <app-icam-icon [iconName]="'sidebar-close'" [iconHeight]="'24px'" />
      </button>
      <img src="../../../../assets/img/Logo_bianco@2x.png" alt="Logo" class="img-logo" />
    </div>
    <div class="menu" [@staggerAnimation]="menuItems.length">
      @for (item of menuItems; track item) {
        <div
          class="menu-item"
          (click)="navigate(item.route, item.auth === true, item.blank)"
          (keydown.enter)="navigate(item.route, item.auth === true, item.blank)"
          tabindex="0"
          role="button"
          [class.selected]="isRouteActive(item.route)"
          [class.light]="isLight"
          [class.dark]="!isLight"
        >
          @if (!isRouteActive(item.route)) {
            <img
              class="icons"
              [src]="getIconPath(isLight ? item.iconLight : item.iconDark, true)"
              alt="Icon"
              [ngClass]="isLight ? 'light' : 'dark'"
            />
          } @else {
            <img
              class="icons"
              [src]="getIconPath(isLight ? item.iconDark : item.iconSelected, true)"
              alt="Icon"
              [ngClass]="isLight ? 'light' : 'dark'"
            />
          }
          <span>{{ item.label | translate }}</span>
        </div>
      }
    </div>
  </div>
  <div class="menu-footer">
    <img [src]="getIconPath('globe')" alt="Icon" />
    <div>
      @for (language of availableLanguages; track language) {
        <span
          class="lang separator"
          [class.selected]="(currentLanguage$ | async) === language.id"
          role="button"
          tabindex="0"
          (click)="selectLanguage(language.id)"
          (keydown.enter)="selectLanguage(language.id)"
          >{{ language.description }}</span
        >
      }
    </div>
    <div>
      <span
        (click)="toggleTheme('light')"
        (keydown.enter)="toggleTheme('light')"
        tabindex="0"
        role="button"
        class="separator"
        [class.selected]="isLightTheme()"
        >Light</span
      >
      <span
        (click)="toggleTheme('dark')"
        (keydown.enter)="toggleTheme('dark')"
        tabindex="0"
        role="button"
        [class.selected]="isDarkTheme()"
        >Dark</span
      >
    </div>
  </div>
</div>

<div class="theme-selector"></div>
